import { Button } from "../../components/ui/Button";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { Input, InputPrice } from "../../components/ui/Input";
import { IoShieldCheckmarkOutline } from "react-icons/io5";

export const BenefitCardInfo = ({ limitBenefit, setValueBenefit, valueBenefit,onGoToRegister }) => (
    <section id="BenefitCardInfo" className={`min-h-screen bg-orange-50 text-white font-sans flex flex-col lg:flex-row`}>
        <div className="mt-20 w-full flex items-center justify-center">
            <div className="max-w-1/2 p-8 lg:pl-20 flex flex-col justify-center">
                <div className="w-full flex items-center justify-center">
                    <div className="">
                        <h1 className="text-gray-800 text-4xl lg:text-3xl font-bold leading-tight mb-4">
                            Desbloqueie já seu benefício no “Meu INSS”: <br />
                            <small className="text-gray-800 text-sm">
                                Ainda não desbloqueou?<span className="text-gray-800"> <a className="underline hover:text-[#462A71] duration-500" href="https://www.gov.br/pt-br/temas/meu-inss">Clique aqui</a> </span> e garanta seu cartão de crédito consignado Bmg.
                                É simples e rápido!</small>
                        </h1>

                        <p className="text-gray-800 text-lg mb-4">
                            💳 Quer praticidade e vantagens exclusivas? O Cartão Consignado BMG é pra você!
                        </p>

                        <ul className="text-gray-800 mb-6 text-white space-y-2">
                            <li className="text-gray-800">✔ Sem anuidade e com juros mais baixos que o rotativo</li>
                            <li className="text-gray-800">✔ Limite de crédito exclusivo para compras e saques</li>
                            <li className="text-gray-800">✔ Desconto direto na folha apenas do valor mínimo da fatura</li>
                            <li className="text-gray-800">✔ Aceito em milhares de estabelecimentos no Brasil e no exterior</li>
                        </ul>
                    </div>
                    <img className="hidden bg-[#FA6300] rounded-full md:block w-[350px]" src="/assets/mulher-segurando-cartao.png" alt="hero-benefit-blocked" />
                </div>
                <br />
                <div className="flex flex-col md:flex-row-reverse">
                    <div className="bg-white p-4 text-black w-full max-w-xl rounded-tl-[10px] rounded-tr-[10px] md:rounded-tl-[10px] md:rounded-tr-[0px] md:rounded-br-[0px] md:rounded-bl-[10px]">
                        <h1 className="flex items-center"><RiMoneyDollarCircleLine color="green" size={35} /> Simule agora mesmo!</h1>
                        <div className="mb-4 mt-4">
                            <InputPrice
                                label={'Valor do seu benefício'}
                                placeholder={'R$ 2.300,00'}
                                prefix={'R$'}
                                value={valueBenefit}
                                onChangeValue={value => setValueBenefit(value)}
                            />
                        </div>
                        {limitBenefit > 0 && <InputPrice
                            disabled
                            className="mt-5"
                            value={limitBenefit}
                            label={'Valor do seu benefício'}
                            placeholder={'R$ 2.300,00'}
                            prefix={'R$'}
                        />}
                        <br />
                        <Button onClick={onGoToRegister} className="w-full">
                            Pedir cartão
                        </Button>
                        <p className="text-xs text-gray-600 mb-2">
                            Cartão Consignado e Cartão Benefício para os aposentados e pensionistas do INSS. Sujeito à análise de crédito, margem consignável disponível e demais condições do Convênio. Utilize o crédito de forma consciente e somente em caso de necessidade.
                            * O prazo está sujeito a análise e é contabilizado a partir da aprovação de crédito.
                        </p>
                    </div>
                    <div className="rounded-tr-[0px] rounded-tl-[0px] rounded-br-[10px] rounded-bl-[10px] md:rounded-tr-[10px] md:rounded-tl-[0px] md:rounded-br-[10px] md:rounded-bl-[0px]   lg:w-1/2 p-8 lg:pr-20 flex flex-col justify-start items-center bg-white text-black rounded-t-3xl lg:rounded-none">
                        <div className="hidden md:block bg-[#4b0082] text-white px-4 py-2 rounded-full mb-6">
                            <span className="flex items-center gap-2"><IoShieldCheckmarkOutline size={20} />Você está em ambiente seguro</span>
                        </div>
                        <img src="/assets/cartao-bmg.png" className="w-[250px] rounded-lg" alt="" />
                        <p className="text-xs text-gray-600">
                            O BMG exerce uma atividade prevista pelo Banco Central.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>)